import {useEffect, useState} from 'react';
import {useLoaderData, useNavigation, useParams} from "react-router-dom";

import {isMobile} from "react-device-detect";

import {setPageTitle} from '../../../../../Helpers/router';

import PreloaderTable from '../../../../../Components/Preloaders/PreloaderTable';

import UserAdminActions from '../../../Components/UserAdminActions'

import TitleWidget from '../../../../Content/Widgets/Title';
import TableView from '../../../../Content/Widgets/Table';

import {useBackdropPreloaderStore} from '../../../../../Stores/backdropPreloader';

import './index.scss';

export default () => {
    const initData = useLoaderData();
    let {tid} = useParams();

    const navigation = useNavigation();

    const {hideBackdropPreloader} = useBackdropPreloaderStore(); // showBackdropPreloader

    const [content, setContent] = useState();
    const [history, setHistory] = useState();
    const [tableOptions, setTableOptions] = useState();

    const baseFields = {
        text: {
            type: 'telegram-user-message',
            placeholder: 'Повідомлення',
            extraData: initData.extraData
        },
    }

    const [fields] = useState(baseFields);

    useEffect(() => {
        setTableOptions(isMobile ? {
            visible: ['text'],
            hidden: [],
            noHeaders: true,
            unfolded: true,
        } : {
            visible: ['text'],
            hidden: [],
            noHeaders: true,
            unfolded: true,
        })

        setPageTitle('Повідомлення користувача ' + tid)
    }, [])

    useEffect(() => {
        if (navigation.state === 'idle') {
            updateHistory(initData);
        }
    }, [navigation])

    function updateHistory(history) {
        setHistory({...history})

        if (history.amount === 0) {
            setContent({
                title: `Повідомлення користувача:`,
            })    
        }
        else if (history.amount <= 20) {
            setContent({
                title: `Повідомленя користувача:`,
            })
        }
        else {
            setContent({
                title: `Останні ${history.order.length} з ${history.amount} повідомлень:`,
            })
        }

        hideBackdropPreloader()
    }

    const selectClasses = (data) => {
        return data?._code
            ? 'tr_' + data?._code.replace(':', '_')
            : '';
    }

    const config = {templateOptions: {}}

    return <div id="Content" className='Content'>
            <div className='TelegramUserMessages'>
                {!fields && <PreloaderTable/>}

                {fields && content && <TitleWidget permits={{}} content={content} config={config} />}

                {fields && history && <TableView
                    showPreloader={!history?.list}
                    content={history}
                    fields={fields}
                    showPagination={true}
                    tableOptions={tableOptions}
                    actions={false}
                    selectClasses={selectClasses}
                />}
            </div>
            <UserAdminActions />
        </div>
}
